import { render, staticRenderFns } from "./bloodCompatibilities.vue?vue&type=template&id=4260ba00&scoped=true"
import script from "./bloodCompatibilities.vue?vue&type=script&lang=js"
export * from "./bloodCompatibilities.vue?vue&type=script&lang=js"
import style0 from "./bloodCompatibilities.vue?vue&type=style&index=0&id=4260ba00&prod&scoped=true&lang=css"
import style1 from "./bloodCompatibilities.vue?vue&type=style&index=1&id=4260ba00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4260ba00",
  null
  
)

export default component.exports